module.exports = __webpack_public_path__ + "img/INSERT_PAST.e4772127.svg";